// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"

// Make Bootstrap available in the window object for use in other scripts
window.bootstrap = bootstrap
